<template>
    <v-card class="pa-4 d-flex flex-column" height="90vh">
        <v-card-title class="d-flex align-center justify-center position-relative">
            <v-btn @click="emit('back')" icon variant="elevated" class="position-absolute" style="left: 0"
                color="primary" size="x-small">
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <h2 class="text-h5 font-weight-bold text-primary text-center w-100">
                Vehicles
            </h2>
        </v-card-title>

        <v-divider class="my-2" />

        <div style="flex: 1; overflow-y: auto;">




            <template v-if="list.length === 0">
                <p class="text-center">There are any vehicles.</p>
            </template>
            <v-virtual-scroll v-else :items="list" height="auto">
                <template v-slot:default="{ item, index }">
                    <VehicleElement :vehicle="item" :key="index" @search="emit('search', item)" />
                </template>
            </v-virtual-scroll>


        </div>
    </v-card>
</template>


<script setup>
import { ref } from 'vue';
import VehicleElement from './VehicleElement.vue';

const props = defineProps({
    list: {
        type: Array,
        default: () => []
    }
});
const emit = defineEmits(['back', 'search']);
const tab = ref('finished');
</script>
